export const data1 = [
  {
    "avatar": "https://pic.pictuku.app:10049/group1/tu/0049tus.png",
    "name": "0049大全",
    "url": "https://zzxxff.0049123c.app:4065/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/733063748/O1CN01JCepK11dYdaK5Nb9G_!!733063748.png",
    "name": "爱我四九",
    "url": "https://zzxxff2549.2549gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01fpKTrI1rqPZj66V42_!!2217565595682.png",
    "name": "横财富",
    "url": "https://zzxxff2076.2076gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01xYEPJq1rqPZWbM0wd_!!2217565595682.png",
    "name": "赛马会",
    "url": "https://zzxxff2085.2085gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01mghdfh1rqPZRZnydR_!!2217565595682.png",
    "name": "小白兔",
    "url": "https://zzxxff13512.13512gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01TJbXTe1rqPZcSzmd1_!!2217565595682.jpg",
    "name": "哮天犬",
    "url": "https://zzxxff60114.60114gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01UpwUOh1rqPZRVHMpO_!!2217565595682.png",
    "name": "铁公鸡",
    "url": "https://zzxxff00179.00179gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01wiR5YU1rqPZRHdjAM_!!2217565595682.png",
    "name": "牛魔王",
    "url": "https://zzxxff125000.125000gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01JhKIzF1rqPZRHdG2i_!!2217565595682.png",
    "name": "美猴王",
    "url": "https://zzxxff126000.126000gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20261/02/13/01.png",
    "name": "马上发",
    "url": "https://zzxxff150888.150888gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20261/02/13/13131311.png",
    "name": "猪八戒",
    "url": "https://zzxxff124000.124000gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20261/02/13/02.png",
    "name": "地头蛇",
    "url": "https://zzxxff12993.12993gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN0193XcSx1rqPZOAPjmP_!!2217565595682.png",
    "name": "同城网",
    "url": "https://zzxxff5801.5801gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01iTdqTr1rqPZEVYuAl_!!2217565595682.png",
    "name": "手机开奖网",
    "url": "https://zzxxff13999.13999gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN012vWfEu1rqPZEVRS58_!!2217565595682.png",
    "name": "九龙网",
    "url": "https://zzxxff901.901gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01jChlW81rqPZEVmjbQ_!!2217565595682.png",
    "name": "人人网",
    "url": "https://zzxxff1492.1492gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://js.qcloudpic.com/group1/49789/49789xiaotu123.jpg",
    "name": "49资料网",
    "url": "https://zzxxff49679.49789gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/8504/8504aa.png",
    "name": "王中王",
    "url": "https://zzxxff8504.8504gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01mZ4o8W1rqPZJzhgEh_!!2217565595682.png",
    "name": "四九第一",
    "url": "https://zzxxff491.491gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/19/%E5%9B%9B%E4%B8%8D%E5%83%8F135x85.png",
    "name": "四不像",
    "url": "https://zzxxff4904.4904gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01Z0sb8H1rqPZJX4uAu_!!2217565595682.png",
    "name": "四九论坛",
    "url": "https://zzxxff4906.4906gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20253/10/26/4908xi.png",
    "name": "开奖网",
    "url": "https://zzxxff4908.4908gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/490/490xtu3.png",
    "name": "490开奖网",
    "url": "https://zzxxff490kjw.490gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/149xt/149xiaotu12.png",
    "name": "149开奖网",
    "url": "https://zzxxffkjw.149gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01aRMq7E1rqPZJzicWK_!!2217565595682.png",
    "name": "开奖网",
    "url": "https://zzxxff4945.4945gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/12/09/3452f.png",
    "name": "百姓网",
    "url": "https://zzxxff1499.1499gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20261/02/02/6244aa.png",
    "name": "铁算盘",
    "url": "https://zzxxff6244.6244gg.app:8450/ok.html#xiaotu"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01bYNDIB1rqPZJkOGCa_!!2217565595682.png",
    "name": "富二代",
    "url": "https://zzxxff60222.60222gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01WCv7Kn1rqPZJTdzzp_!!2217565595682.png",
    "name": "九五至尊",
    "url": "https://zzxxff6095.6095gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/12/08/13838.png",
    "name": "彩霸王",
    "url": "https://zzxxff13838.13838gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/23/13009.png",
    "name": "九华山",
    "url": "https://zzxxff13009.13009gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/03/diyipaologo.png",
    "name": "第一炮",
    "url": "https://zzxxff111109.111109gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/06/135X85%20-(%E9%BE%99%E5%A4%AA%E5%AD%90%EF%BC%89.png",
    "name": "龙太子",
    "url": "https://zzxxff00160.00160gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/14/3360.png",
    "name": "三姐妹",
    "url": "https://zzxxff333360.333360gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/06/%E7%BE%8E%E7%8C%B4%E7%8E%8B135_.png",
    "name": "美猴王",
    "url": "https://zzxxff199444.199444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/17/333380.png",
    "name": "小金库",
    "url": "https://zzxxff333380.333380gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/17/985888.png",
    "name": "清华论坛",
    "url": "https://zzxxff985888.985888gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/17/211888.png",
    "name": "北大论坛",
    "url": "https://zzxxff211888.211888gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN019jprLD1rqPZJTl7Lf_!!2217565595682.png",
    "name": "包青天",
    "url": "https://zzxxff13053.13053gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01DxhxDc1rqPZKn6dxN_!!2217565595682.png",
    "name": "小妖精",
    "url": "https://zzxxff49286.49286gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/14/49251.png",
    "name": "马元帅",
    "url": "https://zzxxff49251.49251gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/06/%E9%BB%84%E5%A4%A7%E4%BB%99%E6%A8%AA%E5%9B%BE%E6%A0%87.png",
    "name": "黄大仙",
    "url": "https://zzxxff134666.134666gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/05/80049-2.png",
    "name": "49办公室",
    "url": "https://zzxxffbgs.80049gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01m6SKLE1rqPZJ4WjkX_!!2217565595682.png",
    "name": "49彩票",
    "url": "https://zzxxff49.49270gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/ggtupian/xintupian.png",
    "name": "49彩票第二",
    "url": "https://4499.4499112.app:4499/#/pages/register/register?promoteCode=4499:4499/#/pages/register/register?promoteCode=004584#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01g34QUO1rqPZZULaEs_!!2217565595682.png",
    "name": "49集团",
    "url": "https://491.4916.app:666/#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/default/20250814/12/35/7/49coxiaotu.png",
    "name": "49图库",
    "url": "https://pa2qtp.49co8.app:4068/49co.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/default/20250814/12/34/7/49cmxiaotu.png",
    "name": "49彩民",
    "url": "https://zzxxff.49cmok.app:4050/49cm.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01vexLSG1rqPZKnEV1Y_!!2217565595682.png",
    "name": "广东论坛",
    "url": "https://zzxxff100555.100555gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250301/21/28/1/49830h1.png",
    "name": "广西论坛",
    "url": "https://zzxxff49830.49830gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49884/49884tuaa.jpg",
    "name": "江西老表",
    "url": "https://zzxxff49884.49884gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01pWsDXQ1rqPZJ4jxfe_!!2217565595682.png",
    "name": "福建论坛",
    "url": "https://zzxxff564444.564444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01euTQyR1rqPZK5wmUH_!!2217565595682.png",
    "name": "大哥论坛",
    "url": "https://zzxxff490000.490000gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01Y28KJg1rqPZEVYMqe_!!2217565595682.png",
    "name": "二哥论坛",
    "url": "https://zzxxff44900.44900gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01KeL9ZR1rqPZJ4eBqe_!!2217565595682.png",
    "name": "三哥论坛",
    "url": "https://zzxxff49560.49560gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/49670/49670aa.jpg",
    "name": "四哥论坛",
    "url": "https://zzxxff49670.49670gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01VC1nCb1rqPZJBoHTB_!!2217565595682.png",
    "name": "49一哥",
    "url": "https://zzxxff490011.490011gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01znICaG1rqPZJzqPJN_!!2217565595682.png",
    "name": "49一路发",
    "url": "https://zzxxff0049168.0049168gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/tu/490888tu11.png",
    "name": "49一定牛",
    "url": "https://zzxxffydn.490888gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN015lwnKm1rqPZJzrLe7_!!2217565595682.png",
    "name": "爱码论坛",
    "url": "https://zzxxffamlt.22549gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01rcqcyu1rqPZEVUo4O_!!2217565595682.png",
    "name": "49凤凰网",
    "url": "https://zzxxff004959.004959gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/004930/004930xiaotu.jpg",
    "name": "49摇钱树",
    "url": "https://zzxxff004930.004930gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/004947/huangdaxian.png",
    "name": "49黄大仙",
    "url": "https://zzxxff004947.004947gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/004910/004910xtu.jpg",
    "name": "49曾道人",
    "url": "https://zzxxff49720.004910gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/fdsds/49347xiaotu1.png",
    "name": "49金光佛",
    "url": "https://zzxxff49347.004972gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/004934/0049xiaotu.jpg",
    "name": "49慈善网",
    "url": "https://zzxxff49304.004934gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/tu/49405xt88.png",
    "name": "49中特网",
    "url": "https://zzxxff49405.004944gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/default/20250729/17/53/7/004970.jpg",
    "name": "49彩霸王",
    "url": "https://zzxxff49715.004970gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/default/20250729/17/35/7/49cmw.png",
    "name": "49彩民网",
    "url": "https://zzxxff49437.004936gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/xiaotu/49246ff.png",
    "name": "49广东会",
    "url": "https://zzxxff49264.004956gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/default/20250729/17/53/7/004950.jpg",
    "name": "49聚宝盆",
    "url": "https://zzxxff49041.004950gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/19016/004969.png",
    "name": "49大贏家",
    "url": "https://zzxxff19016.004969gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01WKb1mN1rqPZJkCRiu_!!2217565595682.png",
    "name": "49大老板",
    "url": "https://zzxxffdlb.49004gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app/group1/49/49753xtu.png",
    "name": "49老论坛",
    "url": "https://zzxxff4933.49753gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/default/20250711/15/25/7/49988xiaotu.jpg",
    "name": "49爸爸",
    "url": "https://zzxxff49988.49988gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/49497/49497xt15.png",
    "name": "49妈妈",
    "url": "https://zzxxffmm.49497gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/77066/77066tu32.png",
    "name": "大明论坛",
    "url": "https://zzxxff77066.77066gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/4978aaaaaa.png",
    "name": "49网址大全",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49979/49979aa.png",
    "name": "49论坛",
    "url": "https://zzxxff49979.49979gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/default/20250614/23/53/7/yiyiyjy.png",
    "name": "kj0077开奖",
    "url": "https://zzxxff490077.490077gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/tu/2025ws.png",
    "name": "开奖网",
    "url": "https://zzxxffkjw.kj2025gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01rEbFZR1rqPZJXFyuC_!!2217565595682.png",
    "name": "开奖网",
    "url": "https://zzxxffkj0049.kj0049gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/05/www49.png",
    "name": "最快开奖",
    "url": "https://zzxxffkj.10049gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/100111/100111aa.jpg",
    "name": "天线宝宝",
    "url": "https://zzxxff100111.100111gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/100222/100222aaaa.png",
    "name": "天空彩票",
    "url": "https://zzxxff100222.100222gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/18/135.png",
    "name": "49金牛网",
    "url": "https://zzxxff49610.49610gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN015lHOVf1rqPZJWvR5c_!!2217565595682.png",
    "name": "49董事长",
    "url": "https://zzxxff0493.0493gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49230/49230aaa.png",
    "name": "湖南论坛",
    "url": "https://zzxxff49230.49230gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49588/49588ss.jpg",
    "name": "大发论坛",
    "url": "https://zzxxff49588.49588gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/49640/49640bac.png",
    "name": "小鱼儿",
    "url": "https://zzxxff49640.49640gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/43/1/13126abab.png",
    "name": "刘半仙",
    "url": "https://zzxxff13126.13126gg.app:8447/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/123788888.png",
    "name": "123开奖",
    "url": "https://zzxxff123919.123779gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01Y3iEEA1rqPZJwHzNj_!!2217565595682.jpg",
    "name": "118开奖",
    "url": "https://zzxxff999118.999117gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/730730/730730aaa.png",
    "name": "青蛙彩票",
    "url": "https://zzxxff730730.730730gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://js.qcloudpic.com/group1/427777/xiaotu2.png",
    "name": "三王论坛",
    "url": "https://zzxxff427777.427777gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01lvZquo1rqPZJzsYQQ_!!2217565595682.png",
    "name": "哪吒论坛",
    "url": "https://zzxxff13071.13071gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/16067/16067xlg.png",
    "name": "蓝月亮",
    "url": "https://zzxxff16067.16067gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/19835/19835aaa.png",
    "name": "刘伯温",
    "url": "https://zzxxff19835.19835gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://js.qcloudpic.com/group1/49346/49346xiaotu123.jpg",
    "name": "老黄历",
    "url": "https://zzxxff49346.49346gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN014X2Z1c1rqPZK5Y90P_!!2217565595682.png",
    "name": "六合日报",
    "url": "https://zzxxff4879.4879gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01saW2qR1rqPZJaoqPX_!!2217565595682.png",
    "name": "土地公",
    "url": "https://zzxxff13169.13169gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xnxx/60730avca.png",
    "name": "宝马论坛",
    "url": "https://zzxxff606050.60730okok.app:4050/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/13035aaaaaa.png",
    "name": "六合资料",
    "url": "https://zzxxff13035.13035gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/26/1/13069.png",
    "name": "白天鹅",
    "url": "https://zzxxff13069.13069gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13021/13021aa.png",
    "name": "港澳大桥",
    "url": "https://zzxxff13021.13021gg.app:8447/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13260/13260aaa.png",
    "name": "特靠谱",
    "url": "https://zzxxff13260.13260gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/36/1/13045abab.png",
    "name": "一品堂",
    "url": "https://zzxxff13045.13045gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/14/49042xintu.png",
    "name": "欢喜就好",
    "url": "https://zzxxff49042.49042gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/880101/880101aa.png",
    "name": "88论坛",
    "url": "https://zzxxff880101.880101gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01QL9Kvj1rqPZJJLxgx_!!2217565595682.png",
    "name": "六合宝典",
    "url": "https://zzxxff49966.49966gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13783/13783rrr.png",
    "name": "黑神话悟空",
    "url": "https://zzxxff13783.13783gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.com:10049/group1/49451/49451tu5.png",
    "name": "49基金会",
    "url": "https://zzxxff49451.49451gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/16/49840.png",
    "name": "龙门客栈",
    "url": "https://zzxxff130160.49840gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13280/13280xiaotuaa.png",
    "name": "横财富",
    "url": "https://zzxxff13280.13280gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49047/49047xlg.png",
    "name": "49跑狗网",
    "url": "https://zzxxff49047.49047gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/1908999aaaaaa.png",
    "name": "黄大仙",
    "url": "https://zzxxff303070.19089gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/11/19849aa.png",
    "name": "雷锋论坛",
    "url": "https://zzxxff19849.19849gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13039/13039tuaa.jpg",
    "name": "9494开奖网",
    "url": "https://zzxxff13039.13039gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13056/logosmall13056.jpg",
    "name": "9494资料网",
    "url": "https://zzxxff13056.13056gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/16012mcmc.png",
    "name": "十二生肖",
    "url": "https://zzxxff12161.12161gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13052/13052aa.png",
    "name": "小鱼儿",
    "url": "https://zzxxff13052.13052gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01mtg59s1rqPZIqfgC8_!!2217565595682.png",
    "name": "49图库",
    "url": "https://zzxxff0498.0498gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/604444/logosmall604444.jpg",
    "name": "白小姐",
    "url": "https://zzxxff604444.604444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/140999/140999aaa.png",
    "name": "摇钱树",
    "url": "https://zzxxff140999.140999gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/28/1/13081.png",
    "name": "澳门头条",
    "url": "https://zzxxff13081.13081gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49084/49084aaa.png",
    "name": "金钥匙",
    "url": "https://zzxxff49084.49084gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/773444/773444aa.png",
    "name": "小龙女",
    "url": "https://zzxxff644666.773444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/28/1/272333.png",
    "name": "杨红公式",
    "url": "https://zzxxff272333.272333gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/13087mcmc.png",
    "name": "管家婆",
    "url": "https://zzxxff13087.13087gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01XzwDA81rqPZJrgLIG_!!2217565595682.png",
    "name": "五路财神",
    "url": "https://zzxxff13752.13752gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/999230303.png",
    "name": "贾专家",
    "url": "https://zzxxff99923.49245gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/kj06aaa.png",
    "name": "kj06开奖网",
    "url": "https://zzxxff130006.kj06gg.app:8447/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/dauca/987333anhthang.jpg",
    "name": "彩民网",
    "url": "https://zzxxff987333.987333gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13034/13034logonho.jpg",
    "name": "福彩公益网",
    "url": "https://zzxxff13034.13034gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/404777/404777tuaabb.jpg",
    "name": "内幕三码",
    "url": "https://zzxxff404777.404777gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49241/49241aa.png",
    "name": "钱多多",
    "url": "https://zzxxff49241.49241gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/dauca/13685anhthang.jpg",
    "name": "状元红",
    "url": "https://zzxxff13685.13685gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/658777/658777aa.png",
    "name": "六玄公式",
    "url": "https://zzxxff043333.658777gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://js.qcloudpic.com/group1/13635/133635xiaotu123.jpg",
    "name": "红姐论坛",
    "url": "https://zzxxff13635.13635gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/352555/352555aaa.png",
    "name": "丰田论坛",
    "url": "https://zzxxff352555.352555gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/55501/55501aa.png",
    "name": "小马哥",
    "url": "https://zzxxff14047.14047gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/15026/15026eee.png",
    "name": "神童网",
    "url": "https://zzxxff15026.15026gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13675/13675aaa.jpg",
    "name": "天天彩票",
    "url": "https://zzxxff13675.13675gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/35045/35045aa.png",
    "name": "神算子",
    "url": "https://zzxxff35045.35045gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://images.last30geng98.top/anhmeo/themhgijo.png",
    "name": "查看更多",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc/#HK"
  },
  {
    "avatar": "https://images.last30geng98.top/anhmeo/themhgijo.png",
    "name": "查看更多",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc/#HK"
  },
  {
    "avatar": "https://images.last30geng98.top/anhmeo/themhgijo.png",
    "name": "查看更多",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc/#HK"
  },
  {
    "avatar": "https://images.last30geng98.top/anhmeo/themhgijo.png",
    "name": "查看更多",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc/#HK"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01wTA1jW1rqPZJBmKnk_!!2217565595682.png",
    "name": "四九挂牌",
    "url": "https://zzxxff49014.49014gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/453555/453555hihi.png",
    "name": "研究生",
    "url": "https://zzxxff453555.453555okok.app:4050/ok.html#lhc"
  },
  {
    "avatar": "https://js.qcloudpic.com/group1/13357/13357xiaotu123.jpg",
    "name": "港澳彩集团",
    "url": "https://zzxxff13357.13357gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/27/1/49874.png",
    "name": "铁算盘",
    "url": "https://zzxxff49874.49874gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/118444/118444aa.png",
    "name": "118开奖网",
    "url": "https://zzxxff13619.13619gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/414999mcmc.png",
    "name": "老奇人",
    "url": "https://zzxxff414999.414999gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13043/13043aa.png",
    "name": "一点红",
    "url": "https://zzxxff13043.13043gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/dauca/15087abc.jpg",
    "name": "澳门内幕网",
    "url": "https://zzxxff15087.15087gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/338444/338444ab.png",
    "name": "澳门财神",
    "url": "https://zzxxff338444.338444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/315444/315444bbb.png",
    "name": "新葡京",
    "url": "https://zzxxff315444.315444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/13261mcmc.png",
    "name": "红楼梦",
    "url": "https://zzxxff13261.13261gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13327/13327tb123.png",
    "name": "娱乐心水",
    "url": "https://zzxxff13327.13327okok.app:4050/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/29/1/13072.png",
    "name": "包青天",
    "url": "https://zzxxff13072.13072gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/35549/35549aa.png",
    "name": "49特码",
    "url": "https://zzxxff35549.35549gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13051/18235aaa.png",
    "name": "港澳论坛",
    "url": "https://zzxxff13051.13051gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13037/13037logonho.jpg",
    "name": "澳门码头",
    "url": "https://zzxxff13037.13037gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/14056/14056aaa.png",
    "name": "六合宝典",
    "url": "https://zzxxff14056.14056gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/311444mcmc.png",
    "name": "极限码皇",
    "url": "https://zzxxff311444.311444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49034/49034uuu.png",
    "name": "广东江门",
    "url": "https://zzxxff49034.49034gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/30/1/18034.png",
    "name": "花仙子",
    "url": "https://zzxxff4879.4879gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01t47zcM1rqPZKn9nkK_!!2217565595682.png",
    "name": "大红鹰",
    "url": "https://zzxxff28849.28849gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/15054/15054aa.png",
    "name": "神算诸葛亮",
    "url": "https://zzxxff15054.15054gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/262333/262333kkk.png",
    "name": "发财网",
    "url": "https://zzxxff262333.262333gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/47888/47888anhnho.jpg",
    "name": "广东陈六爷",
    "url": "https://zzxxff49415.49415gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/187345/187345anhnho.jpg",
    "name": "汕头六哥",
    "url": "https://zzxxff187345.187345gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13695/13695aa.png",
    "name": "澳门红虎",
    "url": "https://zzxxff13695.13695gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49450/49450bb.png",
    "name": "港澳福彩",
    "url": "https://zzxxff49450.49450gg.app:8447/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/29/1/13639.png",
    "name": "陈六子",
    "url": "https://zzxxff13639.13639gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/dauca/4153beyeu.jpg",
    "name": "老六彩吧",
    "url": "https://zzxxff4153.49247gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/16025aaa.png",
    "name": "澳彩天下",
    "url": "https://zzxxff16024.16024gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.pictuku.app:10049/group1/20251/11/08/13449aaa.png",
    "name": "澳门任我發",
    "url": "https://zzxxff13449.13449gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/xm/930555aaa.png",
    "name": "九点半",
    "url": "https://zzxxff930345.930345gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/988444/988444aaa.png",
    "name": "苹果心水网",
    "url": "https://zzxxff988444.988444gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/682111/682111anhnho.jpg",
    "name": "大三巴",
    "url": "https://zzxxff682111.682111gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/49460/49460xiaotuuu.png",
    "name": "香港论坛",
    "url": "https://zzxxff49460.49460gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13093/logosmall13093.jpg",
    "name": "香港日报",
    "url": "https://zzxxff13093.13093gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/default/20250421/20/29/1/13057.png",
    "name": "香港赛马会",
    "url": "https://zzxxff13057.13057gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.ap2026.app:10049/group1/xm/136688aabb.png",
    "name": "香港资料",
    "url": "https://zzxxff136688.136688gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://pic.qcloudpic.app/group1/13083/logosmall13083.jpg",
    "name": "香港六合彩",
    "url": "https://zzxxff13083.13083gg.app:8450/ok.html#lhc"
  },
  {
    "avatar": "https://images.last30geng98.top/anhmeo/themhgijo.png",
    "name": "查看更多",
    "url": "https://zzxxff.4978ok.app:4050/ok.html#lhc/#HK"
  }
]

export const data2 = [
  {
    "name": "0049导航",
    "signature": "0049.com",
    "url": "https://zzxxffdhw.0049gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "爱我四九",
    "signature": "2549.com",
    "url": "https://zzxxff2549.2549gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "横财富",
    "signature": "2076.com",
    "url": "https://zzxxff2076.2076gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "赛马会",
    "signature": "2085.com",
    "url": "https://zzxxff2085.2085gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "同城网",
    "signature": "5801.com",
    "url": "https://zzxxff5801.5801gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "手机开奖网",
    "signature": "13999.com",
    "url": "https://zzxxff13999.13999gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "49资料网",
    "signature": "49789.com",
    "url": "https://zzxxff49679.49789gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "王中王",
    "signature": "8504.com",
    "url": "https://zzxxff8504.8504gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "人人网",
    "signature": "1492.com",
    "url": "https://zzxxff1492.1492gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "四不像",
    "signature": "4904.com",
    "url": "https://zzxxff4904.4904gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "四九论坛",
    "signature": "4906.com",
    "url": "https://zzxxff4906.4906gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "开奖网",
    "signature": "4908.com",
    "url": "https://zzxxff4908.4908gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "四九第一",
    "signature": "6491.com",
    "url": "https://zzxxff491.491gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "九五至尊",
    "signature": "6095.com",
    "url": "https://zzxxff6095.6095gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "铁算盘",
    "signature": "6244.com",
    "url": "https://zzxxff6244.6244gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "凤凰网",
    "signature": "6024.com",
    "url": "https://zzxxff6024.6024gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "最快开奖",
    "signature": "10049.com",
    "url": "https://zzxxffkj.10049gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "开奖网",
    "signature": "4945.com",
    "url": "https://zzxxff4945.4945gg.app:8450/ok.html#wenzi4"
  },
  {
    "name": "49董事长",
    "signature": "0493.com",
    "url": "https://zzxxff0493.0493gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49管理员",
    "signature": "49516.com",
    "url": "https://zzxxff49516.49516gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49总经理",
    "signature": "49160.com",
    "url": "https://zzxxffzjl.49160gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49秘书长",
    "signature": "49493.com",
    "url": "https://zzxxff49493.49493gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49小情人",
    "signature": "49334.com",
    "url": "https://zzxxff49334.49334gg.app:8450:4050/ok.html#wenzi6"
  },
  {
    "name": "49包租婆",
    "signature": "49419.com",
    "url": "https://zzxxff49419.49419gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49五点半",
    "signature": "49530.com",
    "url": "https://zzxxff49530.49530gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49天下彩",
    "signature": "49375.com",
    "url": "https://zzxxff49375.49375gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "顶级论坛",
    "signature": "49299.com",
    "url": "https://zzxxff49299.49299gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "雷锋论坛",
    "signature": "49255.com",
    "url": "https://zzxxff49255.49255gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "六合资料",
    "signature": "49003.com",
    "url": "https://zzxxffliuhe.49003gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "六十论坛",
    "signature": "60607.com",
    "url": "https://zzxxff60607.60607gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49发发顺",
    "signature": "49886.com",
    "url": "https://zzxxff49886.49886gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49九龙网",
    "signature": "49909.com",
    "url": "https://zzxxffwzw.49909gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49高手网",
    "signature": "49253.com",
    "url": "https://zzxxffjrtt.49253gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49金蛇网",
    "signature": "49952.com",
    "url": "https://zzxxff49952.49952gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49情报部",
    "signature": "49338.com",
    "url": "https://zzxxff49338.49338gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49四不像",
    "signature": "49554.com",
    "url": "https://zzxxff49554.49554gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49基金会",
    "signature": "49451.com",
    "url": "https://zzxxff49451.49451gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49状元红",
    "signature": "49474.com",
    "url": "https://zzxxffgdh.49474gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49钱多多",
    "signature": "49617.com",
    "url": "https://zzxxff49617.49617gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49表妹",
    "signature": "49963.com",
    "url": "https://zzxxff49963.49963gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49图库",
    "signature": "0498.com",
    "url": "https://zzxxff0498.0498gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "大三巴",
    "signature": "49838.com",
    "url": "https://zzxxff49838.49838gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "九龙堂",
    "signature": "49867.com",
    "url": "https://zzxxff49867.49867gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "好运来",
    "signature": "49057.com",
    "url": "https://zzxxff49057.49057gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "小鱼儿",
    "signature": "49640.com",
    "url": "https://zzxxff49640.49640gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "澳利澳",
    "signature": "49660.com",
    "url": "https://zzxxff49660.49660gg.app:8447/ok.html#wenzi6"
  },
  {
    "name": "蓝月亮",
    "signature": "49044.com",
    "url": "https://zzxxfflyl.49044gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "118开奖",
    "signature": "49918.com",
    "url": "https://zzxxff118kj.49918gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "123开奖",
    "signature": "491238.com",
    "url": "https://zzxxff123kj.491238gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49宝典",
    "signature": "49752.com",
    "url": "https://zzxxff49752.49752gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "六月天",
    "signature": "49748.com",
    "url": "https://zzxxff49758.49758gg.app:8447/ok.html#wenzi6"
  },
  {
    "name": "49七月天",
    "signature": "49687.com",
    "url": "https://zzxxff49687.49687gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49爷爷",
    "signature": "49183.com",
    "url": "https://zzxxffhcf.49183gg.app:8447/ok.html#wenzi6"
  },
  {
    "name": "49奶奶",
    "signature": "49875.com",
    "url": "https://zzxxffssz.49875gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49爸爸",
    "signature": "49988.com",
    "url": "https://zzxxff49988.49988gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49阿哥",
    "signature": "49821.com",
    "url": "https://zzxxff49821.49821gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49阿公",
    "signature": "49563.com",
    "url": "https://zzxxff49563.49563gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49阿姐",
    "signature": "49341.com",
    "url": "https://zzxxff49341.49341gg.app:8450/ok.html#wenzi6"
  },
  {
    "name": "49彩库",
    "signature": "491688.com",
    "url": "https://zzxxff491688.491688gg.app:8450/ok.html#wenzi6"
  }
]

export const imgdata = [
  {
    "href": "https://zzxxff2549.2549gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/733063748/O1CN01WhvnlE1dYdaMyEzrp_!!733063748.gif"
  },
  {
    "href": "https://zzxxff2076.2076gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01Q3EGy81rqPZhrvTQy_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff2085.2085gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN012PAksg1rqPZacE3AX_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff.x49a4.app:4051/x49.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01BaG1gj1rqPZJC5nhQ_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxffkjw.149gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01YvpcvY1rqPZJBh1r4_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff490kjw.490gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01L4PgMj1rqPZJWu5vJ_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff901.901gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01dCW9BU1rqPZJzhXnF_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxffdhw.0049gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01lGedO11rqPZJkDJla_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff4906.4906gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01F1lHWL1rqPZJ4uIld_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff4908.4908gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01AuJC7B1rqPZJzjQQO_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff13999.13999gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01NADubZ1rqPZJTyXbC_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff11888.11888bu1.app:8446/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN010R815h1rqPZeO6kQh_!!2217565595682.gif"
  },
  {
    "href": "https://491.4916.app:666/",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01qzpq9b1rqPZZmwqiL_!!2217565595682.gif"
  },
  {
    "href": "https://771.771127.app:666/",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01i0HIXF1rqPZKnFAYs_!!2217565595682.gif"
  },
  {
    "href": "https://2226.222610.app:666/",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01a7nLZJ1rqPZJ4XwlT_!!2217565595682.gif"
  },
  {
    "href": "https://1995.19956.app:666/",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN010DZ42c1rqPZJahOIa_!!2217565595682.gif"
  },
  {
    "href": "https://1997.199710.app:666/",
    "src": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN016XmkJV1rqPZJtbg0S_!!2217565595682.gif"
  },
  {
    "href": "https://49.1994972.app:2026/#/pages/register/register?promoteCode=49:2026/#/pages/register/register?promoteCode=004398",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01xkkLEa1rqPZJJB1Pr_!!2217565595682.gif"
  },
  {
    "href": "https://4499.4499118.app:4499/#/pages/register/register?promoteCode=4499:4499/#/pages/register/register?promoteCode=004584",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN01NHSw0B1rqPZJamd6U_!!2217565595682.gif"
  },
  {
    "href": "https://luntan.4933cp92.app:666/",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01cGX6Mb1rqPZJd4sSj_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff2549.2549gg.app:8450/ok.html#13377aqi",
    "src": "https://pic.pictuku.app:10049/group1/20262/03/29/556649.gif"
  },
  {
    "href": "https://zzxxff491.491gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/733063748/O1CN01AzcYnR1dYdaMqIOyh_!!733063748.gif"
  },
  {
    "href": "https://zzxxff1499.1499gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN012sdygj1rqPZJX3IG1_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff1492.1492gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i1/2217565595682/O1CN012fCtrT1rqPZJrIApP_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff5801.5801gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01MRaQ4P1rqPZO6SyRl_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff4904.4904gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01evjr3v1rqPZJTxnrz_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff8499.8499bu1.app:8066/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i4/2217565595682/O1CN01z14Dm71rqPZJkP4F8_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff4945.4945gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i2/2217565595682/O1CN01QA6bjy1rqPZEVRzQP_!!2217565595682.gif"
  },
  {
    "href": "https://zzxxff6024.6024gg.app:8450/ok.html#zhuyehengfu",
    "src": "https://img.alicdn.com/imgextra/i3/2217565595682/O1CN01eLZu4W1rqPZJTk2li_!!2217565595682.gif"
  }
]